module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1766652"
    }
  }, [_c('b', [_vm._v("BUTTERNUT-APPLE SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1767152"
    }
  }, [_c('b', [_c('i', [_vm._v("Nothing can match a pureed vegetable and cream soup for texture and this subtly sweet combination of squash and apples just proves the point.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1768452"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes Cook: 40 to 45 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1768952"
    }
  }, [_vm._v("2 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1769252"
    }
  }, [_vm._v("1 small onion, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1769552"
    }
  }, [_vm._v("2 medium butternut squash (1¾ pounds each), "), _c('br'), _vm._v(" peeled, seeded, and cut into ¾-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1771852"
    }
  }, [_vm._v("¾ pound Golden Delicious apples (2 medium), "), _c('br'), _vm._v(" peeled, cored, and coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1773352"
    }
  }, [_vm._v("1 can (14½ ounces) vegetable broth or")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1774452"
    }
  }, [_vm._v("1¾ cups Vegetable Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1775652"
    }
  }, [_vm._v("1½ cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1776752"
    }
  }, [_vm._v("1 teaspoon freshly chopped fresh thyme or")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1777052"
    }
  }, [_vm._v("¼ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1778052"
    }
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1778352"
    }
  }, [_vm._v("⅛ teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1779352"
    }
  }, [_vm._v("1 cup half-and-half or light cream")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1779952"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 4-quart saucepan, heat oil over medium heat. Add onion and cook until tender and golden, about 10 minutes. Stir in squash, apples, broth, water, thyme, salt, and pepper; heat to boiling over high heat. Reduce heat to low; cover and simmer, stirring often, until squash is very tender, 20 to 25 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1782452"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Spoon one-third of squash mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour puree into bowl. Repeat with remaining mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1784352"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Return puree to saucepan; stir in half-and-half. Heat through over medium heat, stirring occasionally (do not boil). Makes about 9 cups or 8 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1786452"
    }
  }, [_vm._v("Each serving: About 175 calories, 3g protein, 28g carbohydrate, 7mg total fat (3mg saturated), 11mg cholesterol, 525mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1789152"
    }
  }, [_c('b', [_vm._v("SPICY CURRIED CARROT SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1789652"
    }
  }, [_vm._v("Prepare as directed but substitute "), _c('b', [_vm._v("2 pounds carrots,")]), _vm._v(" peeled and cut into 2-inch pieces, for squash. Increase broth to 2 cans. In Step 1, omit thyme and "), _c('b', [_vm._v("add 2 teaspoons curry powder,")]), _vm._v(" and "), _c('b', [_vm._v("2 teaspoons grated fresh ginger.")]), _vm._v(" Omit half-and-half. Makes about 8 cups or 8 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0053_001",
      "src": "Images/9781618371621_0053_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e1793653"
    }
  }, [_vm._v("Butternut-Apple Soup")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f897bc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c47_r1.vue
// module id = 207
// module chunks = 0